import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Box, Slider, Typography, Tooltip } from '@material-ui/core';
import {
	abbreviateNumber,
	getCurrencyIcon,
	getOkrProgressDetails,
	getTime,
	formatNumberWithCommas,
	getMetricFullValue,
	getPercentageUpperValue,
} from '../../../config/utils';
import { Enums } from '../../../config/enums';
import _ from 'lodash';

export const KpiProgressBar: React.FC<any> = (props) => {
	const {
		okr,
		type,
		t,
		showEditLoader,
		currentUser,
		okrMasterData,
		createKr,
		showArchiveList,
		isScoreLocked = false,
		hideProgressText,
		drawerOpen,
	} = props;
	okr.krId = okr.krId ? okr.krId : okr.objectiveId;
	const { color } = getOkrProgressDetails({
		value: okr.score || okr.krScore,
		dueDate: okr.endDate || okr.dueDate,
	});
	const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

	useEffect(() => {
		if (props.isAnyDrawerOpened) {
			if (anchorEl === null) {
				props.isAnyDrawerOpened({
					...props.appDrawerInfo,
					isProgressPopperOpened: false,
				});
			} else {
				props.isAnyDrawerOpened({
					...props.appDrawerInfo,
					isProgressPopperOpened: true,
				});
			}
		}
	}, [anchorEl]);

	useEffect(() => {
		if (showEditLoader.id === 0) {
			setAnchorEl(null);
		}
	}, [showEditLoader]);

	const handlePopperScroll = (event: any, elementId: any) => {
		setTimeout(function () {
			let element = document.getElementById(elementId);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
			}
		}, 100);
	};

	const getCurrencyName = (metricId: any, currencyId: any) => {
		const defaultName = 'Dollar';
		if (metricId === Enums.TWO && okrMasterData && okrMasterData?.metricMasters) {
			const { metricMasters } = okrMasterData;
			const currencyData =
				metricMasters && metricMasters.length > 0 && metricMasters.find((item: any) => item.metricId === metricId);
			if (currencyData) {
				const { metricDataMaster } = currencyData;
				const currencyDetail =
					metricDataMaster &&
					metricDataMaster.length > 0 &&
					metricDataMaster.find((item: any) => item.dataId === currencyId);
				return currencyDetail?.name || defaultName;
			}
			return defaultName;
		}
		return defaultName;
	};

	const getActionableProgressScore = () => {
		return (
			<Box
				className={`kr-progress not-accepted-progress ${
					props.userSelectedCycle?.cycleStatus === Enums.FUTURE_CYCLE_ID && 'future-progress'
				} ${props.userSelectedCycle?.cycleStatus === Enums.PAST_CYCLE_ID && 'past-progress'}`}
				onClick={(e: any) => {
					//handleToggle(e);
					if (type === 'kr') {
						handlePopperScroll(e, `kr-popper-${okr.goalKeyId || okr.krId}`);
					}
				}}
				id={`kr-progress-${okr.goalKeyId || okr.krId}`}
			>
				{okr.metricId === 1 ? (
					//=== Percentage
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider
								aria-label={t('MyGoalProgressSlider')}
								style={{ color }}
								value={okr.score}
								// valueLabelDisplay='on'
								// valueLabelFormat={() => {
								// 	return (
								// 		<Fragment>
								// 			<Typography variant='h4'>{okr.score}%</Typography>
								// 		</Fragment>
								// 	);
								// }}
							/>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 2 ? (
					//=== Currency
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Tooltip
								arrow
								title={
									<Typography variant='body2' className='progress-currency-tooltip'>
										{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
										{okr?.currentValue}
									</Typography>
								}
							>
								<Slider
									aria-label={t('MyGoalProgressSlider')}
									style={{ color }}
									value={okr.score}
									// valueLabelDisplay='on'
									// valueLabelFormat={() => {
									// 	return (
									// 		<Fragment>
									// 			<Typography variant='h4'>{okr.score}%</Typography>
									// 			<Box className='hover-currency-tooltip'>
									// 				<Typography variant='body2'>(</Typography>
									// 				<Box className='hover-currency-icon'>
									// 					{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
									// 					<Typography variant='body2'>{formatNumberWithCommas(okr.currentValue)})</Typography>
									// 				</Box>
									// 			</Box>
									// 		</Fragment>
									// 	);
									// }}
								/>
							</Tooltip>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 3 ? (
					//=== Numbers
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Tooltip arrow title={`#${okr?.currentValue}`}>
								<Slider
									aria-label={t('MyGoalProgressSlider')}
									style={{ color }}
									value={okr.score}
									// valueLabelDisplay='on'
									// valueLabelFormat={() => {
									// 	return (
									// 		<Fragment>
									// 			<Typography variant='h4'>{okr.score}%</Typography>
									// 			<Typography variant='body2'>({formatNumberWithCommas(okr.currentValue)})</Typography>
									// 		</Fragment>
									// 	);
									// }}
								/>
							</Tooltip>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 4 ? (
					//=== Boolean
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider
								aria-label={t('MyGoalProgressSlider')}
								style={{ color }}
								value={okr.score}
								valueLabelDisplay='on'
								valueLabelFormat={() => {
									return (
										<Fragment>
											<Typography>{okr.score}%</Typography>
										</Fragment>
									);
								}}
							/>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 5 ? (
					//=== No Unit
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider
								aria-label={t('MyGoalProgressSlider')}
								style={{ color }}
								value={okr.score}
								// valueLabelDisplay='on'
								// valueLabelFormat={() => {
								// 	return (
								// 		<Fragment>
								// 			<Typography variant='h4'>{okr.score}%</Typography>
								// 		</Fragment>
								// 	);
								// }}
							/>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : (
					<></>
				)}

				<Box className='kr-progress-bottom'>
					{props.userSelectedCycle?.cycleStatus === Enums.FUTURE_CYCLE_ID && !hideProgressText ? (
						<Typography variant='h6'>{t('progRestricted')}</Typography>
					) : isScoreLocked ? (
						!drawerOpen && (
							<Typography className='kr-progress-action' variant='h6'>
								{getTime(okr.keyProgressTime)}
							</Typography>
						)
					) : (
						!drawerOpen && (
							<Typography className='kr-progress-action' variant='h6'>
								{t('clickToUpdateProgress')}
							</Typography>
						)
					)}
					{drawerOpen && okr.metricId !== 1 ? (
						<Box className='kr-settings-value no-right-margin'>
							<Typography variant='h6'>
								{getMetricFullValue(okr.overallScore, okr?.metricId, drawerOpen, okr?.currencyId, okrMasterData)}
							</Typography>
						</Box>
					) : (
						<Box className='kr-settings-value no-right-margin'>
							<Typography variant='h6'></Typography>
						</Box>
					)}
				</Box>
			</Box>
		);
	};

	const getProgressForPeople = () => {
		const time =
			okr.assignmentTypeId === 1
				? okr.keyProgressTime
				: okr.goalProgressTime
				? okr.goalProgressTime
				: okr.keyProgressTime;
		return (
			<Box
				className={`kr-progress people-progress ${
					props.userSelectedCycle?.cycleStatus === Enums.FUTURE_CYCLE_ID && 'future-progress no-cursor'
				} ${props.userSelectedCycle?.cycleStatus === Enums.PAST_CYCLE_ID && 'past-progress'}`}
				id={`kr-progress-${okr?.goalKeyId || okr?.krId}`}
			>
				{okr.metricId === 1 ? (
					//=== Percentage
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider
								aria-label={t('MyGoalProgressSlider')}
								style={{ color }}
								value={okr.score}
								// valueLabelDisplay='on'
								// valueLabelFormat={() => {
								// 	return (
								// 		<Fragment>
								// 			<Typography variant='h4'>{okr.score}%</Typography>
								// 		</Fragment>
								// 	);
								// }}
							/>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 2 ? (
					//=== Currency
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Tooltip
								arrow
								title={
									<Typography variant='body2' className='progress-currency-tooltip'>
										{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
										{okr?.currentValue}
									</Typography>
								}
							>
								<Slider
									aria-label={t('MyGoalProgressSlider')}
									style={{ color }}
									value={okr.score}
									// valueLabelDisplay='on'
									// valueLabelFormat={() => {
									// 	return (
									// 		<Fragment>
									// 			<Typography variant='h4'>{okr.score}%</Typography>
									// 			<Typography variant='body2' className='hover-currency-tooltip'>
									// 				<Typography variant='body2'>(</Typography>
									// 				<Typography className='hover-currency-icon' variant='body2'>
									// 					{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
									// 					<Typography variant='body2'>{formatNumberWithCommas(okr.currentValue)})</Typography>
									// 				</Typography>
									// 			</Typography>
									// 		</Fragment>
									// 	);
									// }}
								/>
							</Tooltip>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 3 ? (
					//=== Numbers
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Tooltip arrow title={`#${okr?.currentValue}`}>
								<Slider
									aria-label={t('MyGoalProgressSlider')}
									style={{ color }}
									value={okr.score}
									// valueLabelDisplay='on'
									// valueLabelFormat={() => {
									// 	return (
									// 		<Fragment>
									// 			<Typography variant='h4'>{okr.score}%</Typography>
									// 			<Typography variant='body2'>({abbreviateNumber(okr.currentValue)})</Typography>
									// 		</Fragment>
									// 	);
									// }}
								/>
							</Tooltip>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 4 ? (
					//=== Boolean
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider
								aria-label={t('MyGoalProgressSlider')}
								style={{ color }}
								value={okr.score}
								// valueLabelDisplay='on'
								// valueLabelFormat={() => {
								// 	return (
								// 		<Fragment>
								// 			<Typography>{okr.score}%</Typography>
								// 		</Fragment>
								// 	);
								// }}
							/>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : okr.metricId === 5 ? (
					//=== No Unit
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider
								aria-label={t('MyGoalProgressSlider')}
								style={{ color }}
								value={okr.score}
								// valueLabelDisplay='on'
								// valueLabelFormat={() => {
								// 	return (
								// 		<Fragment>
								// 			<Typography variant='h4'>{okr.score}%</Typography>
								// 		</Fragment>
								// 	);
								// }}
							/>
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				) : (
					<Fragment>
						{getKrSettingValue()}
						<Box className='kr-progress-slider'>
							<Slider aria-label={t('MyGoalProgressSlider')} style={{ color }} value={okr.score} />
							<Box className='progress-timestamp-info'>
								<Typography variant='h2'>
									{getPercentageUpperValue(okr.score)}
									<sup>%</sup>
								</Typography>
							</Box>
						</Box>
					</Fragment>
				)}

				<Box className='kr-progress-bottom'>
					{props.userSelectedCycle?.cycleStatus === Enums.FUTURE_CYCLE_ID && !hideProgressText ? (
						<Typography className='kr-progress-action' variant='h6'>
							{t('progRestricted')}
						</Typography>
					) : (
						time &&
						!drawerOpen && (
							<Typography className='kr-progress-action' variant='h6'>
								{getTime(time)}
							</Typography>
						)
					)}
				</Box>
			</Box>
		);
	};

	const getKrSettingValue = () => {
		return (
			<Fragment>
				{okr.metricId === 1 ? (
					<Box className='kr-settings-value'>
						<Typography variant='h6'>{abbreviateNumber(okr.startValue)}%</Typography>
						<Typography variant='h6'>{abbreviateNumber(okr.targetValue)}%</Typography>
					</Box>
				) : okr.metricId === 2 ? (
					<Box className='kr-settings-value'>
						<Tooltip arrow title={formatNumberWithCommas(okr.startValue)}>
							<Typography variant='h6'>
								{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
								{/* {okr.startValue} */}
								{drawerOpen ? formatNumberWithCommas(okr.startValue) : abbreviateNumber(okr.startValue)}
							</Typography>
						</Tooltip>
						<Tooltip arrow title={formatNumberWithCommas(okr.targetValue)}>
							<Typography variant='h6'>
								{getCurrencyIcon(getCurrencyName(okr?.metricId, okr?.currencyId))}
								{drawerOpen ? formatNumberWithCommas(okr.targetValue) : abbreviateNumber(okr.targetValue)}
							</Typography>
						</Tooltip>
					</Box>
				) : okr.metricId === 3 ? (
					<Box className='kr-settings-value'>
						<Tooltip arrow title={`${formatNumberWithCommas(okr.startValue)}`}>
							<Typography variant='h6'>
								#{drawerOpen ? formatNumberWithCommas(okr.startValue) : abbreviateNumber(okr.startValue)}
							</Typography>
						</Tooltip>
						<Tooltip arrow title={`${formatNumberWithCommas(okr.targetValue)}`}>
							<Typography variant='h6'>
								#{drawerOpen ? formatNumberWithCommas(okr.targetValue) : abbreviateNumber(okr.targetValue)}
							</Typography>
						</Tooltip>
					</Box>
				) : okr.metricId === 4 ? (
					<Box className='kr-settings-value'>
						<Typography variant='h6'>{t('notAchieved')}</Typography>
						<Typography variant='h6'>{t('achieved')}</Typography>
					</Box>
				) : okr.metricId === 5 ? (
					<Box className='kr-settings-value'>
						<Typography variant='h6'>{abbreviateNumber(okr.startValue)}%</Typography>
						<Typography variant='h6'>{abbreviateNumber(okr.targetValue)}%</Typography>
					</Box>
				) : (
					<></>
				)}
			</Fragment>
		);
	};

	return (
		<Fragment>
			{(okr.goalStatusId === Enums.GOAL_STATUS_DRAFT || showArchiveList || props.newKr) && !props.createKr ? (
				<Box className={`kr-progress orphan-kr-progress`}>
					{getKrSettingValue()}
					<Box className='kr-progress-slider'>
						<Slider
							aria-label={t('MyGoalProgressSlider')}
							style={{ color }}
							value={props.newKr ? 0 : okr.score}
							valueLabelDisplay='off'
							marks={false}
							step={10}
							disabled
						/>
						<Box className='progress-timestamp-info'>
							<Typography variant='h2'>
								0<sup>%</sup>
							</Typography>
						</Box>
					</Box>
					{okr.metricId === 1 ||
					okr.metricId === 2 ||
					okr.metricId === 3 ||
					okr.metricId === 4 ||
					okr.metricId === 5 ? (
						<Box className='kr-progress-bottom'></Box>
					) : (
						<></>
					)}
				</Box>
			) : okr.goalStatusId === Enums.GOAL_STATUS_DRAFT || showArchiveList || props.createKr ? (
				<Box className='kr-progress orphan-kr-progress'>
					{getKrSettingValue()}
					<Box className='kr-progress-slider'>
						<Slider
							aria-label={t('MyGoalProgressSlider')}
							value={okr.score}
							valueLabelDisplay='off'
							marks={false}
							disabled
						/>
						<Box className='progress-timestamp-info'>
							<Typography variant='h2'>
								0<sup>%</sup>
							</Typography>
						</Box>
					</Box>
					<Box className='kr-progress-bottom'></Box>
				</Box>
			) : type === 'okr' ? (
				<Box className='obj-progress'>
					<Box className='obj-progress-slider'>
						<Slider
							aria-label={t('MyGoalProgressSlider')}
							style={{ color }}
							value={okr.score}
							valueLabelDisplay='off'
							marks={false}
							step={10}
							disabled
						/>
						<Box className='progress-timestamp-info'>
							<Typography variant='h2'>
								{getPercentageUpperValue(okr.score)}
								<sup>%</sup>
							</Typography>
						</Box>
					</Box>
					<Box className='kr-progress-bottom'>
						{okr.goalProgressTime &&
							props.userSelectedCycle?.cycleStatus !== Enums.FUTURE_CYCLE_ID &&
							okr.isAnyNonPendingOkr && <Typography variant='h6'>{getTime(okr.goalProgressTime)}</Typography>}
					</Box>
				</Box>
			) : currentUser ||
			  createKr ||
			  props.readOnlyView === true ||
			  props.userSelectedCycle?.cycleStatus === Enums.FUTURE_CYCLE_ID ? (
				getProgressForPeople()
			) : (
				<Fragment>
					{showArchiveList ? (
						<Box
							className={`kr-progress not-accepted-progress ${
								props.userSelectedCycle?.cycleStatus === Enums.FUTURE_CYCLE_ID && 'future-progress'
							} ${props.userSelectedCycle?.cycleStatus === Enums.PAST_CYCLE_ID && 'past-progress'}`}
						>
							{getKrSettingValue()}
							<Box className='kr-progress-slider'>
								<Slider
									aria-label={t('MyGoalProgressSlider')}
									style={{ color }}
									value={okr.score}
									valueLabelDisplay='off'
									marks={false}
									step={10}
									disabled
								/>
								<Box className='progress-timestamp-info'>
									<Typography variant='h2'>
										0<sup>%</sup>
									</Typography>
								</Box>
							</Box>
						</Box>
					) : (
						<Fragment>{getActionableProgressScore()}</Fragment>
					)}
				</Fragment>
			)}
		</Fragment>
	);
};
